import React from 'react'



export const Footer = () => {
    const year = new Date().getFullYear();
  return (
      
    <div>
        <footer>
        <p>Copyright ⓒ Kusum {year}</p>

        </footer>
    </div>
  )
}
